<template>
  <div class="tab-options-style">
    <local-style
        class="template-styles"
        :options="options"
        :container_id="ids.container_id"
        :rect_id="ids.rect_id"
        elementType="cxTabs"
        :styleImgs="request_prefix === 'bigScreen'?styleImages:styleImagesHome"
        @changeQuoteStyle="changeQuoteStyle"
        ref="localStyleComponent"
    />
  </div>
</template>

<script>
import { home_select_children } from "materials/select/menus/index.js"
import defaultImage from "assets/images/default_image.png"
import localStyle from "toolbarComponents/styles/local-style.vue"
export default {
  name: "tab-options-style",
  components: {localStyle},
  props: {
    options: {
      type: Object,
      required: true
    }
  },
  computed: {
    ids() {
      return this.$store.state.states.activeID
    },

  },
  data() {
    return {
      activeImgIndex: undefined,
      defaultImage: defaultImage,
      activeNames: [],
      showLen: 6,
      styleImages: [
        require("../assets/images/tab1.png"),
        require("../assets/images/tab2.png")
      ],
      styleImagesHome: [
        require("../assets/images/tab1.png"),
        require("../assets/images/tab2.png")
      ]
    }
  },
  methods: {
    changeImageStyle(style, index) {
      this.activeImgIndex = index
      let tmpData = JSON.parse(JSON.stringify(style))
      let curOptions = this.$getOptions()
      tmpData.left = curOptions.left
      tmpData.top = curOptions.top
      tmpData.imgSrc = curOptions.imgSrc
      let data = {
        ...this.ids,
        options: tmpData
      }
      this.$store.dispatch(this.request_prefix + "/changeAllOptions", data)
    },
    computedStyle(style) {
      return {
        borderRadius: style.shapeType === "round" ? style.borderRadius : `${style.borderRadius}px`
      }
    },
    showAllStyles() {
      this.$refs.localStyleComponent.showAllStyles()
    },
    changeQuoteStyle(tmpData,curOptions){
          // 当前组件引用其他组件的样式 设置项  如tab引用下拉框的样式
          if(tmpData.options.quoteComponent === 'cxSelect'){
            let options = JSON.parse(JSON.stringify(home_select_children[0].attribute.options))
            options.quoteFrom="cxSelect"
            options.quoteTo="cxTabs"
            options.left = curOptions.left
            options.leftType = curOptions.leftType
            options.top = curOptions.top
            options.topType = curOptions.topType
            options.margin = curOptions.margin
            options.offset = curOptions.offset
            options.menuName = curOptions.menuName
            options.menuIconClass = curOptions.menuIconClass
            options.tabsList = curOptions.tabsList
            options.styleId = tmpData.options.styleId
            options.value = curOptions.tabsList[0]?.name
            // tab 切换到select样式后，tab激活第一个
            options.isPageLayoutTabs = curOptions.isPageLayoutTabs
            let data = {
              ...this.ids,
              options:options
            }
            this.$store.dispatch(this.request_prefix + "/changeAllOptions", data)
          }
    }
  }
}
</script>

<style lang="scss" scoped>
.tab-styles {
  display: flex;
  flex-wrap: wrap;
  text-align: center;
  .tab-style-item {
    width: calc((100% - 32px)/3);
    margin: 0 16px 16px 0;
    box-sizing: border-box;
    // &:nth-child(3n + 1) {
    //   margin-left: 0;
    // }
    &:nth-child(3n) {
      margin-right: 0;
    }
    &.active {
      .tab-style-box {
        border: 1px solid var(--themeColor);
        box-shadow: 0 0 0 1px var(--themeColor);
        .icon-checked {
          display: block;
        }
      }
    }
  }
  .tab-style-box {
    position: relative;
    border-radius: 4px;
    margin-bottom: 8px;
    background-color: var(--styleBgColor);
    border: 1px solid #373737;
    overflow: hidden;
    img {
      width: 100%;
      height: 51px;
    }
    .icon-checked {
      position: absolute;
      right: 0;
      top: 0;
      width: 24px;
      height: 24px;
      background-image: url(../../../assets/images/icon-checked.png);
      background-size: 100% 100%;
      display: none;
    }
  }
  .tab-item {
    border: none;
  }
}
</style>
